<template>
  <el-select v-model="selectPost" placeholder="请选择职务名称" @change="onSelectPostChanged">
    <el-option
      v-for="item in posts"
      :key="item.id"
      :label="item.label"
      :value="item.id">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "selectPosts",
  //lists 选中的职务   type:局级 或 部门级
  props:['post','type','index'],
  data(){
    return{
      selectPost:'',
      posts:[],
    }
  },
  watch:{
    post:{
      immediate:true,
      deep:true,
      handler(val){
        this.selectPost=val;
      }
    },
    type:{
      immediate:true,
      deep:true,
      handler(val){
        this.$commonConfig.getPostsList(val).then(res=>{
            this.posts=res;
        }).catch(error=>{
          this.posts=error;
        })
      }
    }

  },
  methods:{
    onSelectPostChanged(e){
      console.log('e===',e)
      this.$emit('onSelectPostChanged',e,this.index)
    }
  }
}
</script>

<style scoped>

</style>
